import React from 'react';
import cx from 'classnames';
import './FixedBottomNavBar.scss';

const FixedBottomNavBar = (props) => {
  const { className, children, ...res } = props;
  return (
    <div className={cx('fixed-bottom-nav-bar', className)} {...res}>
      {children}
    </div>
  );
};

export default FixedBottomNavBar;
